
import * as ExpoFileSystem from 'expo-file-system';
import * as Print from 'expo-print';
import * as Sharing from 'expo-sharing';

import { Platform } from 'react-native';

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { TDocumentDefinitions } from 'pdfmake/interfaces';

// Assign the VFS data to pdfMake
(pdfMake as any).vfs = pdfFonts.vfs;

// Define custom fonts or use the default ones
pdfMake.fonts = {
    // download default Roboto font from cdnjs.com
    Roboto: {
        normal: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf',
        bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
        italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
        bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
    },
};


export const generatePdfDataURI = (docDefinition: TDocumentDefinitions = { content: 'nothing to show', }, onlyDataFormat = false) => {
    return new Promise(resolve => {

        pdfMake.createPdf(docDefinition).getBase64().then(
            (data: string) => {
                resolve(onlyDataFormat ? data : `data:application/pdf;base64,${data}`);
            },
            (err: string) => {
                console.error(err);
            });

    });
};

export const print = async (docDefinition: TDocumentDefinitions = { content: 'nothing to show', }) => {
    return Platform.select({
        native: async () => {
            try {
                await Print.printAsync({ uri: await generatePdfDataURI(docDefinition) as string, });
            } catch (error) {
                console.error('Printing failed:', error);
            }
        },
        default: async () => {
            try {
                pdfMake.createPdf(docDefinition).print();
            } catch (error) {
                console.error('Printing failed:', error);
            }
        }
    })();
};


export const share = async (docDefinition: TDocumentDefinitions = { content: 'nothing to show', }, filename: string = 'document.pdf') => {
    // Create URI from document definition; request only the base64 data
    const uri = await generatePdfDataURI(docDefinition, true) as string;
    // Sharing dialog title
    const title = 'Share document';
    // Sharing dialog text (web only)
    const text = 'Here is a PDF version of your document';
    // Convert Base64 string to a Uint8Array
    const byteCharacters = atob(uri);
    // const byteNumbers = byteCharacters.split('').map((char) => char.charCodeAt(0));
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    // Sanitize the filename
    filename = filename.replace(/[\/\\:*?"<>|]/g, "_")
        .replace(/\s+/g, " ")
        .trim();

    return Platform.select({
        // Android or iOS
        native: async () => {
            // 1. Check if sharing is available
            if (!(await Sharing.isAvailableAsync())) {
                alert("Sharing is not available on this platform.");
                return;
            }
            try {
                // Create a file instance and write the binary data
                const file = new ExpoFileSystem.File(ExpoFileSystem.Paths.cache, filename);
                await file.create({ intermediates: true });
                // Writes the binary data directly
                await file.write(byteArray);
                // Share the file using its local URI
                await Sharing.shareAsync(file.uri, { mimeType: 'application/pdf', dialogTitle: title, UTI: '.pdf' });
                // (Optional) Delete the temporary file
                file.delete();
            } catch (error) {
                console.error('Error while trying to share the document:', error);
                alert(`${error}`);
            }
        },
        // Web
        default: async () => {
            try {
                // Create blob and file
                const blob = new Blob([byteArray], { type: 'application/pdf' });
                const file = new File([blob], filename, { type: 'application/pdf' });
                // Share the file using navigator.share API
                await navigator.share({ title, text, files: [file] });
            } catch (error) {
                console.error('Error while trying to share the document:', error);
                alert(`Sharing failed: ${error}`);
            }
        }
    })();
};